import { json, request } from '../../shared/api/http';
import type {
  AuthSessionResDto,
  AuthStatusResDto,
  LoginReqDto,
  SetupReqDto,
  ChangePasswordReqDto,
} from './dto';
export const getAuthStatus = () => request<AuthStatusResDto>('/api/auth/status');
export const getCurrentSession = () => request<AuthSessionResDto>('/api/auth/me');
export const logIn = (body: LoginReqDto) =>
  request<AuthSessionResDto>('/api/auth/login', json('POST', body));
export const setupAdmin = (body: SetupReqDto) =>
  request<AuthSessionResDto>('/api/auth/setup', json('POST', body));
export const logOut = () => request<void>('/api/auth/logout', { method: 'POST' });
export const changeOwnPassword = (body: ChangePasswordReqDto) =>
  request<void>('/api/auth/change-password', json('POST', body));
